import { Component, inject, OnInit, signal, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogComponent } from 'src/app/_shared/components/dialog/dialog.component';
import { ChallengesFacade } from 'src/app/challenges/state/challenges.facade';

@Component({
  selector: 'app-daily-dialog',
  templateUrl: './daily-dialog.component.html',
  styleUrls: ['./daily-dialog.component.scss']
})
export class DailyDialogComponent implements OnInit {
  hours: number[] = Array.from({ length: 24 }, (_, index) => index);
  minutes: number[] = Array.from({ length: 60 }, (_, index) => index);

  dailyChallengeFormGroup: FormGroup;
  
  private readonly challengesFacade = inject(ChallengesFacade);
  private readonly fb = inject(FormBuilder);

  initialValue = signal<number|undefined>(undefined);
  
  @ViewChild('dialog') dialog!: DialogComponent;

  ngOnInit() {
    let hours = null;
    let minutes = null;

    if (this.initialValue) {
      ({ hours, minutes } = this.getHoursAndMinutes());
    }

    this.dailyChallengeFormGroup = this.fb.group({
      hours: new FormControl<number>(hours, [Validators.required]),
      minutes: new FormControl<number>(minutes, [Validators.required])
    });
  }

  updateInitialValue() {
    this.initialValue.set(this.challengesFacade.initialValue);
    console.log(this.getHoursAndMinutes());
    this.dailyChallengeFormGroup.setValue(this.getHoursAndMinutes());
  }

  createChallenge() {
    const minutes = parseInt(this.dailyChallengeFormGroup.value.hours) * 60 + parseInt(this.dailyChallengeFormGroup.value.minutes ?? 0);

    if (this.initialValue() !== undefined) {
      this.challengesFacade.putUserDailyChallenge(minutes).subscribe();
    } else {
      this.challengesFacade.postUserDailyChallenge(minutes).subscribe();
    }

    this.dialog.closeDialog();
  }

  closeModal() {
    this.dailyChallengeFormGroup.setValue(this.getHoursAndMinutes());
    this.challengesFacade.setInitialValue(undefined);
    this.dialog.closeDialog();
  }

  private getHoursAndMinutes() {
    const hours = Math.trunc(this.initialValue() / 60);
    const minutes = this.initialValue() % 60;

    return { hours: hours || 0, minutes: minutes || 0 };
  }
}
